export default __webpack_public_path__ + "static/Chalet-NewYorkSixty-ce86578f0678b654dcd04a7ca8161120.woff";